import { Button as MuiButton, SxProps, Theme } from "@mui/material";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { showResetConfirmModal } from './ConfirmFactory';

/**
 * Standardized button for clearing table view preferences.
 * Triggers an industrial-grade confirmation modal with consistent branding.
 */
export const ResetTablePreferencesButton: React.FC<{ 
    onOk: () => void;
    sx?: SxProps<Theme>;
}> = ({ 
    onOk,
    sx = {}
}) => {
    const handleClick = () => {
        showResetConfirmModal({
            title: "Reset Table Preferences?",
            content: "Are you sure you want to reset all table view preferences? This will clear your filters, column order, and other customizations.",
            onOk,
        });
    };

    return (
        <MuiButton
            onClick={handleClick}
            startIcon={<RestartAltIcon />}
            sx={sx}
        >
            Reset View
        </MuiButton>
    );
};
